var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"passport-viz"},[(!_vm.loaded)?_c('loading'):_vm._e(),_c('svg',{ref:"passChart"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }